import { SOFT_VERSION } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/SoftVersionIcon/constants'

function getListBenefits({ softVersion, isLpuPage }) {
  const isStandard = softVersion === SOFT_VERSION.standard
  const isPro = softVersion === SOFT_VERSION.pro
  const isUltima = softVersion === SOFT_VERSION.ultima

  if (isUltima && isLpuPage) {
    return [
      'может использовать брендирование страницы',
      'выделяется в списке клиник',
      'может использовать расширенную аналитику',
      'может обновлять данные о врачах',
      'может отвечать на отзывы',
      'может писать об акциях и скидках',
      'отключает на своей странице рекламу',
      'отслеживает эффективность страницы',
    ]
  }

  return [
    `может обновлять данные о ${isLpuPage ? 'врачах' : 'себе'}`,
    'может отвечать на отзывы',
    (isPro || isStandard) && isLpuPage ? 'может писать об акциях и скидках' : '',
    isPro || isUltima ? 'отключает на своей странице рекламу' : '',
    isPro || isStandard || isUltima ? 'отслеживает эффективность страницы' : '',
    isUltima && !isLpuPage ? 'может публиковать свои контакты' : '',
  ].filter(n => n)
}

export default getListBenefits
